module.exports = __webpack_public_path__ + "img/x5.92d3d516.jpg";